<template>
  <v-layout row wrap class="colored-background">
    <!-- HEADER -->
    <v-flex xs12 sm12 md12 class="mt-5 text-xs-center">
      <img width="70%" :src="assetRoot + 'musicplus.png'" />
    </v-flex>
    <v-flex xs12 sm12 md12 class="mt-5">
      <v-layout row wrap v-for="item in listItems">
        <v-spacer />
        <v-flex xs1 sm1 md1>
          <center>
          <v-img width="1.0rem" :src="assetRoot + 'check.png'" />
        </center>
        </v-flex>
        <v-flex xs8 sm8 md8>
          <span class="list-item-text">{{ item }}</span>
        </v-flex>
        <v-spacer />
      </v-layout>
    </v-flex>
    <!-- APPS -->
    <v-flex xs12 sm12 md12 class="mt-4">
      <store-apps store_mode="organic" />
    </v-flex>
    <!-- BOTTOM HOLDER -->
    <v-flex xs12 sm12 md12 class="bottom-holder my-3"> </v-flex>
  </v-layout>
</template>

<script>
  import { mapGetters } from 'vuex'

  import StoreApps from './StoreApps'

  export default {
    components: {
      'store-apps': StoreApps
    },
    data () {
      return {
        listItems: ['4 apps to learn music included', 'Thousands of songs & lessons', 'No credit card needed'],
      }
    },
    methods: {

    },
    computed: {
      ...mapGetters([
        'assetRoot'
      ])
    },
    mounted () {
      this.$nextTick(function () {

      })
    }
  }
</script>

<style scoped>

.colored-background {
  background-size: contain;
  background-image:url('https://storage.googleapis.com/mwm-appstore-assets/website_mwm/global_offer/BG-opti.jpg');
  background-color: #05151F;
}

.thank-you {
  font-family: CenturyGothic;
  font-size: 35px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff;
}

.finalize-account {
  font-family: CenturyGothic;
  font-size: 17px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff;
}

.finalize-account .action {
  color: #2c7fff;
}

.account-creation-for {
  font-family: CenturyGothic;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff;
}

.account-creation-for .email {
  font-weight: bold;
  color: #7dff00;
}

.bottom-holder {
  height: 1px;
}

.list-item-text {
  font-family: CenturyGothic;
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.44;
  letter-spacing: normal;
  color: #ffffff;
}

</style>
